export const COMMON_ENTITY_STRINGS = {
  EXTERNAL_IDENTIFIERS_LABEL: 'External Identifiers',
  EXTERNAL_IDENTIFIER_LABEL: 'External Identifier',
  EXTERNAL_IDENTIFIER_NAME_LABEL: 'Identifier Name',
  EXTERNAL_IDENTIFIER_VALUE_LABEL: 'Identifier Value',
  ATTRIBUTE_DEPRECATED: 'Deprecated Attribute',
  ATTRIBUTE_URL_DEPRECATED_DESCRIPTION:
    'This URL-based image attribute is deprecated. Please use the image picker field below instead.',
  TITLE_LABEL: 'Title',
  TYPE: 'Type',
};
